module.exports = "/_next/static/images/e3a371d34146a24fceb9484982449059-people-smile-at-home-xs@3x.jpg.webp";